import { IBusinessRuleService } from "../../service/evaluation/BusinessRuleService";

export default class GetBusinessRulesInteractor {
  private businessRuleService: IBusinessRuleService;

  constructor(businessRuleService) {
    this.businessRuleService = businessRuleService;
  }

  async execute() {
    return this.businessRuleService.getBusinessRules();
  }
}
